import React, { useState, useEffect, useRef } from 'react';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/*! js-cookie v3.0.1 | MIT */
/* eslint-disable no-var */
function assign (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target
}
/* eslint-enable no-var */

/* eslint-disable no-var */
var defaultConverter = {
  read: function (value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
  },
  write: function (value) {
    return encodeURIComponent(value).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    )
  }
};
/* eslint-enable no-var */

/* eslint-disable no-var */

function init (converter, defaultAttributes) {
  function set (key, value, attributes) {
    if (typeof document === 'undefined') {
      return
    }

    attributes = assign({}, defaultAttributes, attributes);

    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }

    key = encodeURIComponent(key)
      .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
      .replace(/[()]/g, escape);

    var stringifiedAttributes = '';
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue
      }

      stringifiedAttributes += '; ' + attributeName;

      if (attributes[attributeName] === true) {
        continue
      }

      // Considers RFC 6265 section 5.2:
      // ...
      // 3.  If the remaining unparsed-attributes contains a %x3B (";")
      //     character:
      // Consume the characters of the unparsed-attributes up to,
      // not including, the first %x3B (";") character.
      // ...
      stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }

    return (document.cookie =
      key + '=' + converter.write(value, key) + stringifiedAttributes)
  }

  function get (key) {
    if (typeof document === 'undefined' || (arguments.length && !key)) {
      return
    }

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      var value = parts.slice(1).join('=');

      try {
        var foundKey = decodeURIComponent(parts[0]);
        jar[foundKey] = converter.read(value, foundKey);

        if (key === foundKey) {
          break
        }
      } catch (e) {}
    }

    return key ? jar[key] : jar
  }

  return Object.create(
    {
      set: set,
      get: get,
      remove: function (key, attributes) {
        set(
          key,
          '',
          assign({}, attributes, {
            expires: -1
          })
        );
      },
      withAttributes: function (attributes) {
        return init(this.converter, assign({}, this.attributes, attributes))
      },
      withConverter: function (converter) {
        return init(assign({}, this.converter, converter), this.attributes)
      }
    },
    {
      attributes: { value: Object.freeze(defaultAttributes) },
      converter: { value: Object.freeze(converter) }
    }
  )
}

var api = init(defaultConverter, { path: '/' });

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$5 = "@charset \"UTF-8\";\n/**\n* @license\n* MyFonts Webfont Build ID 3556768, 2018-04-12T01:44:02-0400\n* \n* The fonts listed in this notice are subject to the End User License\n* Agreement(s) entered into by the website owner. All other parties are \n* explicitly restricted from using the Licensed Webfonts(s).\n* \n* You may obtain a valid license at the URLs below.\n* \n* Webfont: ObjektivMk1-Bold by Dalton Maag\n* URL: https://www.myfonts.com/fonts/daltonmaag/objektiv/1bold/\n* \n* Webfont: ObjektivMk1-Medium by Dalton Maag\n* URL: https://www.myfonts.com/fonts/daltonmaag/objektiv/1medium/\n* \n* Webfont: ObjektivMk1-Regular by Dalton Maag\n* URL: https://www.myfonts.com/fonts/daltonmaag/objektiv/1regular/\n* \n* \n* License: https://www.myfonts.com/viewlicense?type=web&buildid=3556768\n* Licensed pageviews: Unlimited\n* Webfonts copyright: Copyright 2015 Dalton Maag Ltd. Modification of this file requires prior written permission from Dalton Maag Ltd.\n* \n* © 2018 MyFonts Inc\n*/\n@font-face {\n  font-family: \"ObjektivMk1-Bold\";\n  src: url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_0_0.eot\");\n  src: url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_0_0.eot?#iefix\") format(\"embedded-opentype\"), url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_0_0.woff2\") format(\"woff2\"), url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_0_0.woff\") format(\"woff\"), url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_0_0.ttf\") format(\"truetype\");\n  font-weight: normal;\n}\n@font-face {\n  font-family: \"ObjektivMk1-Medium\";\n  src: url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_1_0.eot\");\n  src: url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_1_0.eot?#iefix\") format(\"embedded-opentype\"), url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_1_0.woff2\") format(\"woff2\"), url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_1_0.woff\") format(\"woff\"), url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_1_0.ttf\") format(\"truetype\");\n  font-weight: normal;\n}\n@font-face {\n  font-family: \"ObjektivMk1-Regular\";\n  src: url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_2_0.eot\");\n  src: url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_2_0.eot?#iefix\") format(\"embedded-opentype\"), url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_2_0.woff2\") format(\"woff2\"), url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_2_0.woff\") format(\"woff\"), url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_2_0.ttf\") format(\"truetype\");\n  font-weight: normal;\n}\n/** Common **/\n/** main **/\n/** main **/\n/** main **/\n/** main **/\n/** TYPOGRAPHY **/\n/** reflect bootstrap screen size **/\n.ConsentBar-module_consentBar__GOcwR {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding: 15px 25px;\n  font-size: 13px;\n  background-color: #F7F7F7;\n  z-index: 1000;\n}\n\n.ConsentBar-module_content__L9Hg- {\n  display: block;\n  max-width: 1140px;\n  margin: auto;\n}\n@media (min-width: 768px) {\n  .ConsentBar-module_content__L9Hg- {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n}\n\n.ConsentBar-module_cta__Lkl16 {\n  display: flex;\n  margin: 15px auto 0;\n  justify-content: end;\n}\n@media (min-width: 768px) {\n  .ConsentBar-module_cta__Lkl16 {\n    flex: 1 0 260px;\n    margin-top: 0;\n  }\n}\n\n.ConsentBar-module_consentBar__text__kX5WJ {\n  margin-right: 20px;\n}\n\n.ConsentBar-module_link__1NvH- {\n  color: #555555;\n  text-decoration: underline;\n}\n\n.ConsentBar-module_paragraph__ym74s {\n  color: #555555;\n  font-size: 13px;\n  margin-top: 0;\n}";
var styles$5 = {"consentBar":"ConsentBar-module_consentBar__GOcwR","content":"ConsentBar-module_content__L9Hg-","cta":"ConsentBar-module_cta__Lkl16","consentBar__text":"ConsentBar-module_consentBar__text__kX5WJ","link":"ConsentBar-module_link__1NvH-","paragraph":"ConsentBar-module_paragraph__ym74s"};
styleInject(css_248z$5);

var css_248z$4 = "@charset \"UTF-8\";\n/**\n* @license\n* MyFonts Webfont Build ID 3556768, 2018-04-12T01:44:02-0400\n* \n* The fonts listed in this notice are subject to the End User License\n* Agreement(s) entered into by the website owner. All other parties are \n* explicitly restricted from using the Licensed Webfonts(s).\n* \n* You may obtain a valid license at the URLs below.\n* \n* Webfont: ObjektivMk1-Bold by Dalton Maag\n* URL: https://www.myfonts.com/fonts/daltonmaag/objektiv/1bold/\n* \n* Webfont: ObjektivMk1-Medium by Dalton Maag\n* URL: https://www.myfonts.com/fonts/daltonmaag/objektiv/1medium/\n* \n* Webfont: ObjektivMk1-Regular by Dalton Maag\n* URL: https://www.myfonts.com/fonts/daltonmaag/objektiv/1regular/\n* \n* \n* License: https://www.myfonts.com/viewlicense?type=web&buildid=3556768\n* Licensed pageviews: Unlimited\n* Webfonts copyright: Copyright 2015 Dalton Maag Ltd. Modification of this file requires prior written permission from Dalton Maag Ltd.\n* \n* © 2018 MyFonts Inc\n*/\n@font-face {\n  font-family: \"ObjektivMk1-Bold\";\n  src: url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_0_0.eot\");\n  src: url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_0_0.eot?#iefix\") format(\"embedded-opentype\"), url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_0_0.woff2\") format(\"woff2\"), url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_0_0.woff\") format(\"woff\"), url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_0_0.ttf\") format(\"truetype\");\n  font-weight: normal;\n}\n@font-face {\n  font-family: \"ObjektivMk1-Medium\";\n  src: url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_1_0.eot\");\n  src: url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_1_0.eot?#iefix\") format(\"embedded-opentype\"), url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_1_0.woff2\") format(\"woff2\"), url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_1_0.woff\") format(\"woff\"), url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_1_0.ttf\") format(\"truetype\");\n  font-weight: normal;\n}\n@font-face {\n  font-family: \"ObjektivMk1-Regular\";\n  src: url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_2_0.eot\");\n  src: url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_2_0.eot?#iefix\") format(\"embedded-opentype\"), url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_2_0.woff2\") format(\"woff2\"), url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_2_0.woff\") format(\"woff\"), url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_2_0.ttf\") format(\"truetype\");\n  font-weight: normal;\n}\n/** Common **/\n/** main **/\n/** main **/\n/** main **/\n/** main **/\n/** TYPOGRAPHY **/\n/** reflect bootstrap screen size **/\n.Button-module_button__w9lRx {\n  border: 0;\n  background-color: rgba(255, 255, 255, 0);\n  border-radius: 24.5px;\n  font-family: \"ObjektivMk1-Bold\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif;\n  text-transform: uppercase;\n  background-color: white;\n  box-shadow: 0px 5px 15px rgba(2, 38, 64, 0.1);\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: 2px;\n  padding: 15px 35px 13px 35px;\n  cursor: pointer;\n}\n.Button-module_button__w9lRx.Button-module_sm__sady1 {\n  font-size: 12px;\n  letter-spacing: 1.5px;\n  line-height: 18px;\n  padding: 12px 20px 8px 20px;\n}\n\n.Button-module_primary__QBplH {\n  background-color: #022640;\n  color: white;\n}";
var styles$4 = {"button":"Button-module_button__w9lRx","sm":"Button-module_sm__sady1","primary":"Button-module_primary__QBplH"};
styleInject(css_248z$4);

function Button(_ref) {
  let {
    style,
    size,
    label,
    onClick
  } = _ref;
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: `${styles$4.button} ${styles$4[size]} ${styles$4[style]}`,
    onClick: onClick
  }, label);
}

function ConsentBar$2(_ref) {
  let {
    promptManage,
    acceptAll,
    translation
  } = _ref;
  const t = translation.ConsentBar;
  return /*#__PURE__*/React.createElement("div", {
    className: styles$5.consentBar
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$5.content
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$5.text
  }, /*#__PURE__*/React.createElement("p", {
    className: styles$5.paragraph
  }, t.text, t.privacy_link && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(React.Fragment, null, ' '), /*#__PURE__*/React.createElement("a", {
    className: styles$5.link,
    href: t.privacy_link
  }, t.privacy_label)), ".")), /*#__PURE__*/React.createElement("div", {
    className: styles$5.cta
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      marginRight: '10px'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    label: t.manage_label,
    onClick: promptManage
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    style: "primary",
    label: t.accept_label,
    onClick: acceptAll
  })))));
}

var css_248z$3 = "@charset \"UTF-8\";\n/**\n* @license\n* MyFonts Webfont Build ID 3556768, 2018-04-12T01:44:02-0400\n* \n* The fonts listed in this notice are subject to the End User License\n* Agreement(s) entered into by the website owner. All other parties are \n* explicitly restricted from using the Licensed Webfonts(s).\n* \n* You may obtain a valid license at the URLs below.\n* \n* Webfont: ObjektivMk1-Bold by Dalton Maag\n* URL: https://www.myfonts.com/fonts/daltonmaag/objektiv/1bold/\n* \n* Webfont: ObjektivMk1-Medium by Dalton Maag\n* URL: https://www.myfonts.com/fonts/daltonmaag/objektiv/1medium/\n* \n* Webfont: ObjektivMk1-Regular by Dalton Maag\n* URL: https://www.myfonts.com/fonts/daltonmaag/objektiv/1regular/\n* \n* \n* License: https://www.myfonts.com/viewlicense?type=web&buildid=3556768\n* Licensed pageviews: Unlimited\n* Webfonts copyright: Copyright 2015 Dalton Maag Ltd. Modification of this file requires prior written permission from Dalton Maag Ltd.\n* \n* © 2018 MyFonts Inc\n*/\n@font-face {\n  font-family: \"ObjektivMk1-Bold\";\n  src: url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_0_0.eot\");\n  src: url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_0_0.eot?#iefix\") format(\"embedded-opentype\"), url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_0_0.woff2\") format(\"woff2\"), url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_0_0.woff\") format(\"woff\"), url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_0_0.ttf\") format(\"truetype\");\n  font-weight: normal;\n}\n@font-face {\n  font-family: \"ObjektivMk1-Medium\";\n  src: url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_1_0.eot\");\n  src: url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_1_0.eot?#iefix\") format(\"embedded-opentype\"), url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_1_0.woff2\") format(\"woff2\"), url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_1_0.woff\") format(\"woff\"), url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_1_0.ttf\") format(\"truetype\");\n  font-weight: normal;\n}\n@font-face {\n  font-family: \"ObjektivMk1-Regular\";\n  src: url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_2_0.eot\");\n  src: url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_2_0.eot?#iefix\") format(\"embedded-opentype\"), url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_2_0.woff2\") format(\"woff2\"), url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_2_0.woff\") format(\"woff\"), url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_2_0.ttf\") format(\"truetype\");\n  font-weight: normal;\n}\n/** Common **/\n/** main **/\n/** main **/\n/** main **/\n/** main **/\n/** TYPOGRAPHY **/\n/** reflect bootstrap screen size **/\n.ConsentManageModal-module_backdrop__dkckd {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  background-color: rgba(2, 38, 64, 0.7);\n  z-index: 1000;\n}\n\n.ConsentManageModal-module_consentManage__BIEqZ {\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background-color: white;\n  padding: 30px;\n  border-top: 4px solid #C1E5F0;\n  z-index: 2000;\n  max-height: 100vh;\n  overflow-y: auto;\n}\n.ConsentManageModal-module_consentManage__BIEqZ p {\n  color: #555555;\n}\n@media (min-width: 576px) {\n  .ConsentManageModal-module_consentManage__BIEqZ {\n    top: 50%;\n    left: 50%;\n    bottom: auto;\n    right: auto;\n    max-width: 560px;\n    width: 80%;\n    transform: translate(-50%, -50%);\n  }\n}\n\n.ConsentManageModal-module_body__HNZPE {\n  padding: 20px 0;\n}\n\n.ConsentManageModal-module_heading__CHuLw {\n  font-family: \"ObjektivMk1-Bold\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif;\n  font-size: 22px;\n  font-weight: normal;\n  color: #022640;\n  margin-top: 0;\n}\n\n.ConsentManageModal-module_sub__F--6K {\n  margin-bottom: 0;\n  font-size: 14px;\n}\n\n.ConsentManageModal-module_footer__KwDer {\n  padding-top: 20px;\n  border-top: 1px solid #C8C8C8;\n  text-align: right;\n}\n\n.ConsentManageModal-module_group__AqNzz {\n  display: flex;\n  justify-content: space-between;\n}\n\n.ConsentManageModal-module_groupHeading__z7GJM {\n  font-family: \"ObjektivMk1-Bold\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif;\n  font-size: 14px;\n  font-weight: normal;\n  text-transform: uppercase;\n  letter-spacing: 2px;\n  color: #022640;\n  margin: 0 0 5px;\n}\n\n.ConsentManageModal-module_groupText__BoUOl {\n  padding-right: 20px;\n  margin-bottom: 20px;\n  color: #555555;\n  font-size: 13px;\n  margin-top: 0;\n}";
var styles$3 = {"backdrop":"ConsentManageModal-module_backdrop__dkckd","consentManage":"ConsentManageModal-module_consentManage__BIEqZ","body":"ConsentManageModal-module_body__HNZPE","heading":"ConsentManageModal-module_heading__CHuLw","sub":"ConsentManageModal-module_sub__F--6K","footer":"ConsentManageModal-module_footer__KwDer","group":"ConsentManageModal-module_group__AqNzz","groupHeading":"ConsentManageModal-module_groupHeading__z7GJM","groupText":"ConsentManageModal-module_groupText__BoUOl"};
styleInject(css_248z$3);

var css_248z$2 = "@charset \"UTF-8\";\n/**\n* @license\n* MyFonts Webfont Build ID 3556768, 2018-04-12T01:44:02-0400\n* \n* The fonts listed in this notice are subject to the End User License\n* Agreement(s) entered into by the website owner. All other parties are \n* explicitly restricted from using the Licensed Webfonts(s).\n* \n* You may obtain a valid license at the URLs below.\n* \n* Webfont: ObjektivMk1-Bold by Dalton Maag\n* URL: https://www.myfonts.com/fonts/daltonmaag/objektiv/1bold/\n* \n* Webfont: ObjektivMk1-Medium by Dalton Maag\n* URL: https://www.myfonts.com/fonts/daltonmaag/objektiv/1medium/\n* \n* Webfont: ObjektivMk1-Regular by Dalton Maag\n* URL: https://www.myfonts.com/fonts/daltonmaag/objektiv/1regular/\n* \n* \n* License: https://www.myfonts.com/viewlicense?type=web&buildid=3556768\n* Licensed pageviews: Unlimited\n* Webfonts copyright: Copyright 2015 Dalton Maag Ltd. Modification of this file requires prior written permission from Dalton Maag Ltd.\n* \n* © 2018 MyFonts Inc\n*/\n@font-face {\n  font-family: \"ObjektivMk1-Bold\";\n  src: url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_0_0.eot\");\n  src: url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_0_0.eot?#iefix\") format(\"embedded-opentype\"), url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_0_0.woff2\") format(\"woff2\"), url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_0_0.woff\") format(\"woff\"), url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_0_0.ttf\") format(\"truetype\");\n  font-weight: normal;\n}\n@font-face {\n  font-family: \"ObjektivMk1-Medium\";\n  src: url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_1_0.eot\");\n  src: url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_1_0.eot?#iefix\") format(\"embedded-opentype\"), url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_1_0.woff2\") format(\"woff2\"), url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_1_0.woff\") format(\"woff\"), url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_1_0.ttf\") format(\"truetype\");\n  font-weight: normal;\n}\n@font-face {\n  font-family: \"ObjektivMk1-Regular\";\n  src: url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_2_0.eot\");\n  src: url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_2_0.eot?#iefix\") format(\"embedded-opentype\"), url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_2_0.woff2\") format(\"woff2\"), url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_2_0.woff\") format(\"woff\"), url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_2_0.ttf\") format(\"truetype\");\n  font-weight: normal;\n}\n/** Common **/\n/** main **/\n/** main **/\n/** main **/\n/** main **/\n/** TYPOGRAPHY **/\n/** reflect bootstrap screen size **/\n.Switch-module_switch__zVC53 {\n  position: relative;\n  display: inline-block;\n  width: 48px;\n  min-width: 48px;\n  height: 24px;\n  margin-bottom: 0px;\n}\n\n.Switch-module_switch__zVC53 input {\n  display: none;\n}\n\n.Switch-module_slider__oAjYC {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n  border-radius: 24px;\n}\n\n.Switch-module_slider__oAjYC:before {\n  position: absolute;\n  content: \"\";\n  height: 18px;\n  width: 18px;\n  left: 5px;\n  bottom: 3px;\n  background-color: white;\n  -webkit-transition: 0.2s;\n  transition: 0.2s;\n  border-radius: 50%;\n}\n\ninput:checked + .Switch-module_slider__oAjYC {\n  background-color: #022640;\n}\n\ninput:checked:disabled + .Switch-module_slider__oAjYC {\n  background-color: #C8C8C8;\n}\n\ninput:focus + .Switch-module_slider__oAjYC {\n  box-shadow: 0 0 1px #022640;\n}\n\ninput:checked + .Switch-module_slider__oAjYC:before {\n  -webkit-transform: translateX(20px);\n  -ms-transform: translateX(20px);\n  transform: translateX(20px);\n}";
var styles$2 = {"switch":"Switch-module_switch__zVC53","slider":"Switch-module_slider__oAjYC"};
styleInject(css_248z$2);

function Switch(_ref) {
  let {
    field,
    checked,
    setValue,
    disabled
  } = _ref;
  return /*#__PURE__*/React.createElement("label", {
    className: styles$2.switch
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    name: `consent__${field}`,
    checked: checked,
    onChange: e => setValue(field, e.target.checked),
    disabled: disabled
  }), /*#__PURE__*/React.createElement("span", {
    className: styles$2.slider
  }));
}

function ConsentManageModal(_ref) {
  let {
    consentForm,
    setConsentField,
    saveConsent,
    translation
  } = _ref;
  const t = translation.ConsentManage;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles$3.consentManage
  }, /*#__PURE__*/React.createElement("h2", {
    className: styles$3.heading
  }, t.heading), /*#__PURE__*/React.createElement("p", {
    className: styles$3.sub
  }, t.sub), /*#__PURE__*/React.createElement("div", {
    className: styles$3.body
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$3.group
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h6", {
    className: styles$3.groupHeading
  }, t.required_heading), /*#__PURE__*/React.createElement("p", {
    className: styles$3.groupText
  }, t.required_text)), /*#__PURE__*/React.createElement(Switch, {
    checked: true,
    disabled: true
  })), /*#__PURE__*/React.createElement("div", {
    className: styles$3.group
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h6", {
    className: styles$3.groupHeading
  }, t.analytics_heading), /*#__PURE__*/React.createElement("p", {
    className: styles$3.groupText
  }, t.analytics_text)), /*#__PURE__*/React.createElement(Switch, {
    field: "analytics",
    checked: consentForm.analytics,
    setValue: setConsentField
  })), /*#__PURE__*/React.createElement("div", {
    className: styles$3.group
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h6", {
    className: styles$3.groupHeading
  }, t.marketing_heading), /*#__PURE__*/React.createElement("p", {
    className: styles$3.groupText,
    style: {
      marginBottom: 0
    }
  }, t.marketing_text)), /*#__PURE__*/React.createElement(Switch, {
    field: "marketing",
    checked: consentForm.marketing,
    setValue: setConsentField
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles$3.footer
  }, /*#__PURE__*/React.createElement(Button, {
    style: "primary",
    label: t.cta_label,
    onClick: () => saveConsent(consentForm)
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles$3.backdrop
  }));
}

var css_248z$1 = "@charset \"UTF-8\";\n/**\n* @license\n* MyFonts Webfont Build ID 3556768, 2018-04-12T01:44:02-0400\n* \n* The fonts listed in this notice are subject to the End User License\n* Agreement(s) entered into by the website owner. All other parties are \n* explicitly restricted from using the Licensed Webfonts(s).\n* \n* You may obtain a valid license at the URLs below.\n* \n* Webfont: ObjektivMk1-Bold by Dalton Maag\n* URL: https://www.myfonts.com/fonts/daltonmaag/objektiv/1bold/\n* \n* Webfont: ObjektivMk1-Medium by Dalton Maag\n* URL: https://www.myfonts.com/fonts/daltonmaag/objektiv/1medium/\n* \n* Webfont: ObjektivMk1-Regular by Dalton Maag\n* URL: https://www.myfonts.com/fonts/daltonmaag/objektiv/1regular/\n* \n* \n* License: https://www.myfonts.com/viewlicense?type=web&buildid=3556768\n* Licensed pageviews: Unlimited\n* Webfonts copyright: Copyright 2015 Dalton Maag Ltd. Modification of this file requires prior written permission from Dalton Maag Ltd.\n* \n* © 2018 MyFonts Inc\n*/\n@font-face {\n  font-family: \"ObjektivMk1-Bold\";\n  src: url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_0_0.eot\");\n  src: url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_0_0.eot?#iefix\") format(\"embedded-opentype\"), url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_0_0.woff2\") format(\"woff2\"), url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_0_0.woff\") format(\"woff\"), url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_0_0.ttf\") format(\"truetype\");\n  font-weight: normal;\n}\n@font-face {\n  font-family: \"ObjektivMk1-Medium\";\n  src: url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_1_0.eot\");\n  src: url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_1_0.eot?#iefix\") format(\"embedded-opentype\"), url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_1_0.woff2\") format(\"woff2\"), url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_1_0.woff\") format(\"woff\"), url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_1_0.ttf\") format(\"truetype\");\n  font-weight: normal;\n}\n@font-face {\n  font-family: \"ObjektivMk1-Regular\";\n  src: url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_2_0.eot\");\n  src: url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_2_0.eot?#iefix\") format(\"embedded-opentype\"), url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_2_0.woff2\") format(\"woff2\"), url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_2_0.woff\") format(\"woff\"), url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_2_0.ttf\") format(\"truetype\");\n  font-weight: normal;\n}\n/** Common **/\n/** main **/\n/** main **/\n/** main **/\n/** main **/\n/** TYPOGRAPHY **/\n/** reflect bootstrap screen size **/\n.ConsentUpdateModal-module_backdrop__rShVH {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  background-color: rgba(2, 38, 64, 0.7);\n  z-index: 1000;\n}\n\n.ConsentUpdateModal-module_consentUpdate__Bgkss {\n  position: fixed;\n  background-color: white;\n  top: 50%;\n  left: 50%;\n  bottom: auto;\n  right: auto;\n  padding: 30px;\n  transform: translate(-50%, -50%);\n  min-width: 80%;\n  border-top: 4px solid #C1E5F0;\n  z-index: 2000;\n}\n.ConsentUpdateModal-module_consentUpdate__Bgkss p, .ConsentUpdateModal-module_consentUpdate__Bgkss a {\n  color: #555555;\n  font-size: 14px;\n}\n.ConsentUpdateModal-module_consentUpdate__Bgkss a {\n  text-decoration: underline;\n}\n@media (min-width: 576px) {\n  .ConsentUpdateModal-module_consentUpdate__Bgkss {\n    min-width: 0;\n    max-width: 560px;\n  }\n}\n\n.ConsentUpdateModal-module_body__FPbAN {\n  overflow-y: auto;\n  padding: 20px 0;\n  max-height: 60vh;\n}\n@media (min-width: 576px) {\n  .ConsentUpdateModal-module_body__FPbAN {\n    max-height: 40vh;\n  }\n}\n\n.ConsentUpdateModal-module_heading__P7-QK {\n  font-family: \"ObjektivMk1-Bold\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif;\n  font-size: 22px;\n  color: #022640;\n  margin-top: 0;\n}\n\n.ConsentUpdateModal-module_sub__U1lZA {\n  margin-bottom: 0;\n}\n\n.ConsentUpdateModal-module_footer__-qSx6 {\n  text-align: right;\n}\n\n.ConsentUpdateModal-module_group__kh1Lu {\n  display: flex;\n  align-items: flex-start;\n}\n\n.ConsentUpdateModal-module_groupHeading__wQKGv {\n  font-family: \"ObjektivMk1-Bold\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif;\n  font-size: 14px;\n  text-transform: uppercase;\n  letter-spacing: 2px;\n  color: #022640;\n  margin: 0 0 5px;\n}\n\n.ConsentUpdateModal-module_groupText__vrqjX {\n  padding-right: 20px;\n  margin-bottom: 20px;\n  color: #555555;\n  font-size: 13px;\n  margin-top: 0;\n}\n\n.ConsentUpdateModal-module_update__yAOPG {\n  margin: 0 0 5px;\n}";
var styles$1 = {"backdrop":"ConsentUpdateModal-module_backdrop__rShVH","consentUpdate":"ConsentUpdateModal-module_consentUpdate__Bgkss","body":"ConsentUpdateModal-module_body__FPbAN","heading":"ConsentUpdateModal-module_heading__P7-QK","sub":"ConsentUpdateModal-module_sub__U1lZA","footer":"ConsentUpdateModal-module_footer__-qSx6","group":"ConsentUpdateModal-module_group__kh1Lu","groupHeading":"ConsentUpdateModal-module_groupHeading__wQKGv","groupText":"ConsentUpdateModal-module_groupText__vrqjX","update":"ConsentUpdateModal-module_update__yAOPG"};
styleInject(css_248z$1);

function ConsentUpdateModal(_ref) {
  let {
    updates,
    consentForm,
    saveConsent,
    translation
  } = _ref;
  const t = translation.ConsentUpdate;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles$1.consentUpdate
  }, /*#__PURE__*/React.createElement("h2", {
    className: styles$1.heading
  }, t.heading), /*#__PURE__*/React.createElement("p", {
    className: styles$1.text
  }, t.updates_text), /*#__PURE__*/React.createElement("div", null, updates.split('\n').map((point, i) => /*#__PURE__*/React.createElement("p", {
    key: i,
    className: styles$1.update
  }, point))), /*#__PURE__*/React.createElement("p", {
    className: styles$1.text
  }, t.policy_text, " ", /*#__PURE__*/React.createElement("a", {
    href: t.privacy_link
  }, t.privacy_label), "."), /*#__PURE__*/React.createElement("div", {
    className: styles$1.footer
  }, /*#__PURE__*/React.createElement(Button, {
    style: "primary",
    label: t.cta_label,
    onClick: () => saveConsent(consentForm)
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles$1.backdrop
  }));
}

const FI_en = {
  ConsentBar: {
    text: 'We use cookies to make our service easier for you to use, to analyse website traffic, and to personalise content for you. You can learn more about cookies or manage them individually by clicking “Manage”. You can find more information and withdraw your consent at any time by visiting',
    privacy_label: 'Privacy Policy',
    privacy_link: 'https://app.blok.ai/privacy/?_language=en',
    manage_label: 'Manage',
    accept_label: 'Accept'
  },
  ConsentManage: {
    heading: 'Privacy Settings',
    sub: 'Manage your privacy features below',
    required_heading: 'Required',
    required_text: 'These cookies are essential so you can move around the website.',
    analytics_heading: 'Analytics',
    analytics_text: 'Analytical cookies are used to understand how visitors interact with the website. These cookies help provide information about the number of visitors, how much time they spend on the site, and more.',
    marketing_heading: 'Marketing',
    marketing_text: 'These cookies are used to deliver information to you and to measure the effectiveness of such advertisements. We and our advertising partners will use the data to show you ads that you might be interested in.',
    cta_label: 'Save choices'
  },
  ConsentUpdate: {
    heading: 'Privacy Policy Updates',
    updates_text: 'We have just updated our privacy policy with the following information:',
    policy_text: 'You can read our privacy policy in full at our',
    privacy_label: 'privacy page',
    privacy_link: 'https://app.blok.ai/privacy/?_language=en',
    cta_label: 'OK'
  }
};
const FI_fi = {
  ConsentBar: {
    text: 'Evästeillä huolehdimme palvelumme helposta ja nopeasta käyttökokemuksesta, kohdistaaksemme sisällön suoraan sinulle sekä analysoidaksemme sivujen liikennettä. Voit lukea evästeistä lisää tai hallita niitä yksitellen painamalla "Muokkaa". Löydät lisätietoa ja voit milloin vain peruuttaa suostumuksesi sivulla',
    privacy_label: 'Yksityisyyskäytäntö',
    privacy_link: 'https://app.blok.ai/privacy/?_language=fi',
    manage_label: 'Muokkaa',
    accept_label: 'Hyväksy'
  },
  ConsentManage: {
    heading: 'Yksityisyysasetukset',
    sub: 'Hallitse yksityisyysominaisuuksia täältä',
    required_heading: 'Välttämättömät evästeet',
    required_text: 'Nämä evästeet ovat välttämättömiä sivustolla liikkumisen mahdollistamiseksi ja sen ominaisuuksien käyttämiseksi. Tarvitsemiasi palveluita ei voida tarjota ilman näitä evästeitä.',
    analytics_heading: 'Analytiikka',
    analytics_text: 'Käytämme analytiikkaan liittyviä evästeitä ymmärtääksemme, kuinka vierailijat käyttävät sivustoa. Nämä evästeet auttavat tuottamaan tietoa kävijämääristä, sivustolla käytetystä ajasta sekä muun muassa mistä sivustolle on päädytty.',
    marketing_heading: 'Markkinointi',
    marketing_text: 'Näillä evästeillä kohdistamme markkinointia sekä mittaamme sen tehokkuutta. Me ja markkinointiyhteistyötä kanssamme tekevät tahot käytämme dataasi näyttääksemme mainoksia, jotka voisivat kiinnostaa sinua.',
    cta_label: 'Tallenna valinnat'
  },
  ConsentUpdate: {
    heading: 'Tietosuojakäytäntö muuttunut',
    updates_text: 'Olemme päivittäneet tietosuojakäytäntöämme seuraavasti:',
    policy_text: 'Pääset tutustumaan tietosuojakäytäntöömme kokonaisuudessaan',
    privacy_label: 'tietosuojasivullamme',
    privacy_link: 'https://app.blok.ai/privacy/?_language=fi',
    cta_label: 'OK'
  }
};
const FI_sv = {
  ConsentBar: {
    text: 'Vi använder cookies för att göra vår tjänst enklare att använda för dig, för att anpassa innehåll, och för att analysera webbplatstrafik. Du kan lära dig mer om cookies eller hantera dem individuellt genom att klicka på "Hantera". Du kan när som helst hitta mer information och återkalla ditt samtycke genom att besöka',
    privacy_label: 'Sekretesspolicy',
    privacy_link: 'https://app.blok.ai/privacy/?_language=sv',
    manage_label: 'Hantera',
    accept_label: 'Acceptera'
  },
  ConsentManage: {
    heading: 'Sekretessinställningar',
    sub: 'Hantera dina sekretessfunktioner här',
    required_heading: 'Obligatoriskt',
    required_text: 'Dessa cookies behövs för att du ska kunna flytta runt på webbplatsen. Tjänster du har bett om kan inte tillhandahållas utan dessa cookies.',
    analytics_heading: 'Analytics',
    analytics_text: 'Analytiska cookies används för att förstå hur besökare interagerar med webbplatsen. Dessa cookies hjälper till att ge information om antalet besökare, hur mycket tid de spenderar på webbplatsen, hur de har hamnat på webbplatsen och mer.',
    marketing_heading: 'Marknadsföring',
    marketing_text: 'Dessa cookies används för att leverera information till dig och för att mäta effektiviteten av sådana annonser. Vi och våra reklampartners kommer att använda uppgifterna för att visa dig annonser som du kan vara intresserad av. ',
    cta_label: 'Spara val'
  },
  ConsentUpdate: {
    heading: 'Uppdateringar av integritetspolicy',
    updates_text: 'Vi har precis uppdaterat vår integritetspolicy med följande information:',
    policy_text: 'Du kan läsa vår integritetspolicy i sin helhet på vår',
    privacy_label: 'integritetssida',
    privacy_link: 'https://app.blok.ai/privacy/?_language=sv',
    cta_label: 'OK'
  }
};

const SE_en = {
  ConsentBar: {
    text: 'We use cookies to make our service easier for you to use, to analyse website traffic, and to personalise content for you. You can learn more about cookies or manage them individually by clicking “Manage”. You can find more information and withdraw your consent at any time by visiting',
    privacy_label: 'Privacy Policy',
    privacy_link: 'https://app.blok.ai/privacy/?_language=en',
    manage_label: 'Manage',
    accept_label: 'Accept'
  },
  ConsentManage: {
    heading: 'Privacy Settings',
    sub: 'Manage your privacy features below',
    required_heading: 'Required',
    required_text: 'These cookies are essential so you can move around the website.',
    analytics_heading: 'Analytics',
    analytics_text: 'Analytical cookies are used to understand how visitors interact with the website. These cookies help provide information about the number of visitors, how much time they spend on the site, and more.',
    marketing_heading: 'Marketing',
    marketing_text: 'These cookies are used to deliver information to you and to measure the effectiveness of such advertisements. We and our advertising partners will use the data to show you ads that you might be interested in.',
    cta_label: 'Save choices'
  },
  ConsentUpdate: {
    heading: 'Privacy Policy Updates',
    updates_text: 'We have just updated our privacy policy with the following information:',
    policy_text: 'You can read our privacy policy in full at our',
    privacy_label: 'privacy page',
    privacy_link: 'https://app.blok.ai/privacy/?_language=en',
    cta_label: 'OK'
  }
};
const SE_sv = {
  ConsentBar: {
    text: 'Vi använder cookies för att göra vår tjänst enklare att använda för dig, för att anpassa innehåll, och för att analysera webbplatstrafik. Du kan lära dig mer om cookies eller hantera dem individuellt genom att klicka på "Hantera". Du kan när som helst hitta mer information och återkalla ditt samtycke genom att besöka',
    privacy_label: 'Sekretesspolicy',
    privacy_link: 'https://app.blok.ai/privacy/?_language=sv',
    manage_label: 'Hantera',
    accept_label: 'Acceptera'
  },
  ConsentManage: {
    heading: 'Sekretessinställningar',
    sub: 'Hantera dina sekretessfunktioner här',
    required_heading: 'Obligatoriskt',
    required_text: 'Dessa cookies behövs för att du ska kunna flytta runt på webbplatsen. Tjänster du har bett om kan inte tillhandahållas utan dessa cookies.',
    analytics_heading: 'Analytics',
    analytics_text: 'Analytiska cookies används för att förstå hur besökare interagerar med webbplatsen. Dessa cookies hjälper till att ge information om antalet besökare, hur mycket tid de spenderar på webbplatsen, hur de har hamnat på webbplatsen och mer.',
    marketing_heading: 'Marknadsföring',
    marketing_text: 'Dessa cookies används för att leverera information till dig och för att mäta effektiviteten av sådana annonser. Vi och våra reklampartners kommer att använda uppgifterna för att visa dig annonser som du kan vara intresserad av. ',
    cta_label: 'Spara val'
  },
  ConsentUpdate: {
    heading: 'Uppdateringar av integritetspolicy',
    updates_text: 'Vi har precis uppdaterat vår integritetspolicy med följande information:',
    policy_text: 'Du kan läsa vår integritetspolicy i sin helhet på vår',
    privacy_label: 'integritetssida',
    privacy_link: 'https://app.blok.ai/privacy/?_language=sv',
    cta_label: 'OK'
  }
};

const LEAD_SE_en = {
  ConsentBar: {
    text: 'We use cookies to make our service easier for you to use, to analyse website traffic, and to personalise content for you. You can learn more about cookies or manage them individually by clicking “Manage”',
    privacy_label: 'Privacy Policy',
    privacy_link: null,
    manage_label: 'Manage',
    accept_label: 'Accept'
  },
  ConsentManage: {
    heading: 'Privacy Settings',
    sub: 'Manage your privacy features below',
    required_heading: 'Required',
    required_text: 'These cookies are essential so you can move around the website.',
    analytics_heading: 'Analytics',
    analytics_text: 'Analytical cookies are used to understand how visitors interact with the website. These cookies help provide information about the number of visitors, how much time they spend on the site, and more.',
    marketing_heading: 'Marketing',
    marketing_text: 'These cookies are used to deliver information to you and to measure the effectiveness of such advertisements. We and our advertising partners will use the data to show you ads that you might be interested in.',
    cta_label: 'Save choices'
  },
  ConsentUpdate: {
    heading: 'Privacy Policy Updates',
    updates_text: 'We have just updated our privacy policy with the following information:',
    policy_text: 'You can read our privacy policy in full at our',
    privacy_label: 'privacy page',
    privacy_link: 'https://app.blok.ai/privacy/?_language=en',
    cta_label: 'OK'
  }
};
const LEAD_SE_sv = {
  ConsentBar: {
    text: 'Vi använder cookies för att göra vår tjänst enklare att använda för dig, för att anpassa innehåll, och för att analysera webbplatstrafik. Du kan lära dig mer om cookies eller hantera dem individuellt genom att klicka på "Hantera"',
    privacy_label: 'Sekretesspolicy',
    privacy_link: null,
    manage_label: 'Hantera',
    accept_label: 'Acceptera'
  },
  ConsentManage: {
    heading: 'Sekretessinställningar',
    sub: 'Hantera dina sekretessfunktioner här',
    required_heading: 'Obligatoriskt',
    required_text: 'Dessa cookies behövs för att du ska kunna flytta runt på webbplatsen. Tjänster du har bett om kan inte tillhandahållas utan dessa cookies.',
    analytics_heading: 'Analytics',
    analytics_text: 'Analytiska cookies används för att förstå hur besökare interagerar med webbplatsen. Dessa cookies hjälper till att ge information om antalet besökare, hur mycket tid de spenderar på webbplatsen, hur de har hamnat på webbplatsen och mer.',
    marketing_heading: 'Marknadsföring',
    marketing_text: 'Dessa cookies används för att leverera information till dig och för att mäta effektiviteten av sådana annonser. Vi och våra reklampartners kommer att använda uppgifterna för att visa dig annonser som du kan vara intresserad av. ',
    cta_label: 'Spara val'
  },
  ConsentUpdate: {
    heading: 'Uppdateringar av integritetspolicy',
    updates_text: 'Vi har precis uppdaterat vår integritetspolicy med följande information:',
    policy_text: 'Du kan läsa vår integritetspolicy i sin helhet på vår',
    privacy_label: 'integritetssida',
    privacy_link: 'https://app.blok.ai/privacy/?_language=sv',
    cta_label: 'OK'
  }
};

var ConsentBar$1 = {
	text: "We use cookies to make our service easier for you to use, to analyse website traffic, and to personalise content for you. You can learn more about cookies or manage them individually by clicking “Manage”",
	privacy_label: "Privacy Policy",
	privacy_link: null,
	manage_label: "Manage",
	accept_label: "Accept"
};
var ConsentManage$1 = {
	heading: "Privacy Settings",
	sub: "Manage your privacy features below",
	required_heading: "Required",
	required_text: "These cookies are essential so you can move around the website.",
	analytics_heading: "Analytics",
	analytics_text: "Analytical cookies are used to understand how visitors interact with the website. These cookies help provide information about the number of visitors, how much time they spend on the site, and more.",
	marketing_heading: "Marketing",
	marketing_text: "These cookies are used to deliver information to you and to measure the effectiveness of such advertisements. We and our advertising partners will use the data to show you ads that you might be interested in.",
	cta_label: "Save choices"
};
var ConsentUpdate$1 = {
	heading: "Privacy Policy Updates",
	updates_text: "We have just updated our privacy policy with the following information:",
	policy_text: "You can read our privacy policy in full at our",
	privacy_label: "privacy page",
	privacy_link: "https://app.blok.ai/privacy/?_language=en",
	cta_label: "OK"
};
var en = {
	ConsentBar: ConsentBar$1,
	ConsentManage: ConsentManage$1,
	ConsentUpdate: ConsentUpdate$1
};

var ConsentBar = {
	text: "Vi bruker informasjonskapsler for å gjøre tjenesten vår enklere å bruke, for å tilpasse innhold og analysere trafikken på nettstedet. Du kan lære mer om informasjonskapsler eller administrere dem individuelt ved å klikke på \"Administrer\".",
	privacy_label: "Sekretesspolicy",
	privacy_link: null,
	manage_label: "Administrer",
	accept_label: "Aksepter"
};
var ConsentManage = {
	heading: "Personverninnstillinger",
	sub: "Håndter dine personverninnstillinger her.",
	required_heading: "Obligatorisk",
	required_text: "Disse informasjonskapslene er nødvendige for at du skal kunne bruke våre tjenester. Tjenester du har bedt om, kan ikke leveres uten disse informasjonskapslene.",
	analytics_heading: "Analytics",
	analytics_text: "Analytiske informasjonskapsler brukes for å forstå hvordan besøkende samhandler med nettstedet. Disse informasjonskapslene bidrar til å gi informasjon om antall besøkende, hvor mye tid de bruker på nettstedet, hvordan de kom til nettstedet og mer.",
	marketing_heading: "Markedsføring",
	marketing_text: "Disse informasjonskapslene brukes til å levere informasjon til deg og for å måle effektiviteten til slike annonser. Vi og våre annonsepartnere vil bruke dataene til å vise deg annonser som kan være av interesse for deg.",
	cta_label: "Lagre valg"
};
var ConsentUpdate = {
	heading: "Oppdateringer av personvernregler",
	updates_text: "Vi har nettopp oppdatert vår personvernerklæring med følgende informasjon:",
	policy_text: "Du kan lese år personvernerklæring i sin helhet på vår",
	privacy_label: "personvernside",
	privacy_link: "https://app.blok.ai/privacy/?_language=nb",
	cta_label: "OK"
};
var nb = {
	ConsentBar: ConsentBar,
	ConsentManage: ConsentManage,
	ConsentUpdate: ConsentUpdate
};

const LEAD_NO_en = en;
const LEAD_NO_nb = nb;

const getTranslation = (site, language) => {
  switch (site) {
    case 'SE':
      switch (language) {
        case 'sv':
          return SE_sv;

        default:
          return SE_en;
      }

    case 'LEAD_SE':
      switch (language) {
        case 'sv':
          return LEAD_SE_sv;

        default:
          return LEAD_SE_en;
      }

    case 'LEAD_NO':
      switch (language) {
        case 'nb':
          return LEAD_NO_nb;

        default:
          return LEAD_NO_en;
      }

    default:
      switch (language) {
        case 'fi':
          return FI_fi;

        case 'sv':
          return FI_sv;

        default:
          return FI_en;
      }

  }
};

function useScript(src) {
  // Keep track of script status ("idle", "loading", "ready", "error")
  const [status, setStatus] = useState(src ? 'loading' : 'idle');
  useEffect(() => {
    // Allow falsy src value if waiting on other data needed for
    // constructing the script URL passed to this hook.
    if (!src) {
      setStatus('idle');
      return;
    } // Fetch existing script element by src
    // It may have been added by another intance of this hook


    let script = document.querySelector(`script[src="${src}"]`);

    if (!script) {
      // Create script
      script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.setAttribute('data-status', 'loading'); // Add script to document body

      document.body.appendChild(script); // Store status in attribute on script
      // This can be read by other instances of this hook

      const setAttributeFromEvent = event => {
        script.setAttribute('data-status', event.type === 'load' ? 'ready' : 'error');
      };

      script.addEventListener('load', setAttributeFromEvent);
      script.addEventListener('error', setAttributeFromEvent);
    } else {
      // Grab existing script status from attribute and set to state.
      setStatus(script.getAttribute('data-status'));
    } // Script event handler to update status in state
    // Note: Even if the script already exists we still need to add
    // event handlers to update the state for *this* hook instance.


    const setStateFromEvent = event => {
      setStatus(event.type === 'load' ? 'ready' : 'error');
    }; // Add event listeners


    script.addEventListener('load', setStateFromEvent);
    script.addEventListener('error', setStateFromEvent); // Remove event listeners on cleanup

    return () => {
      if (script) {
        script.removeEventListener('load', setStateFromEvent);
        script.removeEventListener('error', setStateFromEvent);
      }
    };
  }, [src] // Only re-run effect if script src changes
  );
  return status;
}

function MarketingTrack(_ref) {
  let {
    consent,
    granularConsent
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, consent || granularConsent.includes('_facebook_') ? /*#__PURE__*/React.createElement(FacebookPixelsTrack, null) : null);
}

function FacebookPixelsTrack() {
  useScript('https://blok-tracking.storage.googleapis.com/shared/facebook_pixels.js');
  return null;
}

function MarketingTrack_FI(_ref) {
  let {
    consent,
    granularConsent
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, consent || granularConsent.includes('_taboola_') ? /*#__PURE__*/React.createElement(TaboolaTrack$2, null) : null, consent || granularConsent.includes('_adwords_') ? /*#__PURE__*/React.createElement(GoogleAdsTrack$2, null) : null, consent || granularConsent.includes('_yah_') ? /*#__PURE__*/React.createElement(YahooGeminiTrack$1, null) : null);
}

function TaboolaTrack$2() {
  useScript('https://blok-tracking.storage.googleapis.com/FI/taboola.js');
  return null;
}

function GoogleAdsTrack$2() {
  useScript('https://www.googletagmanager.com/gtag/js?id=AW-861697012');
  useScript('https://blok-tracking.storage.googleapis.com/FI/aw.js');
  return null;
}

function YahooGeminiTrack$1() {
  useScript('https://blok-tracking.storage.googleapis.com/FI/yahoo.js');
  return null;
}

function MarketingTrack_SE(_ref) {
  let {
    consent,
    granularConsent
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, consent || granularConsent.includes('_taboola_') ? /*#__PURE__*/React.createElement(TaboolaTrack$1, null) : null, consent || granularConsent.includes('_adwords_') ? /*#__PURE__*/React.createElement(GoogleAdsTrack$1, null) : null, consent || granularConsent.includes('_ptr_') ? /*#__PURE__*/React.createElement(PinterestTrack, null) : null, consent || granularConsent.includes('_yah_') ? /*#__PURE__*/React.createElement(YahooGeminiTrack, null) : null);
}

function TaboolaTrack$1() {
  useScript('https://blok-tracking.storage.googleapis.com/SE/taboola.js');
  return null;
}

function GoogleAdsTrack$1() {
  useScript('https://www.googletagmanager.com/gtag/js?id=AW-710008183');
  useScript('https://blok-tracking.storage.googleapis.com/SE/aw.js');
  return null;
}

function PinterestTrack() {
  useScript('https://blok-tracking.storage.googleapis.com/SE/pinterest.js');
  return null;
}

function YahooGeminiTrack() {
  useScript('https://blok-tracking.storage.googleapis.com/SE/yahoo.js');
  return null;
}

function MarketingTrack_NO() {
  // NO scripts
  return null;
}

function MarketingTrack_LEAD_SE(_ref) {
  let {
    consent,
    granularConsent
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, consent || granularConsent.includes('_taboola_') ? /*#__PURE__*/React.createElement(TaboolaTrack, null) : null, consent || granularConsent.includes('_adwords_') ? /*#__PURE__*/React.createElement(GoogleAdsTrack, null) : null, consent || granularConsent.includes('_ob_') ? /*#__PURE__*/React.createElement(OutbrainTrack, null) : null);
}

function TaboolaTrack() {
  useScript('https://blok-tracking.storage.googleapis.com/LEAD_SE/taboola.js');
  return null;
}

function OutbrainTrack() {
  useScript('https://blok-tracking.storage.googleapis.com/LEAD_SE/outbrain.js');
  return null;
}

function GoogleAdsTrack() {
  useScript('https://www.googletagmanager.com/gtag/js?id=AW-10932228524');
  useScript('https://blok-tracking.storage.googleapis.com/LEAD_SE/aw.js');
  return null;
}

function MarketingTrack_LEAD_NO(_ref) {

  /* TODO */
  return;
}

function OptionalTracking(_ref) {
  let {
    site
  } = _ref;
  const [marketingConsent, setMarketingConsent] = useState(false);
  const [granularConsent, setGranularConsent] = useState(null);
  useEffect(() => {
    let consent = {
      analytics: false,
      marketing: false
    };
    const cookie = api.get('blok_consent_client');

    if (cookie) {
      consent = JSON.parse(cookie);
    }

    setMarketingConsent(consent.marketing);

    if ('parties' in consent) {
      setGranularConsent(consent.parties);
    }
  }, []);
  const countryElement = {
    'FI': /*#__PURE__*/React.createElement(MarketingTrack_FI, {
      consent: marketingConsent,
      granularConsent: granularConsent
    }),
    'SE': /*#__PURE__*/React.createElement(MarketingTrack_SE, {
      consent: marketingConsent,
      granularConsent: granularConsent
    }),
    'NO': /*#__PURE__*/React.createElement(MarketingTrack_NO, {
      consent: marketingConsent,
      granularConsent: granularConsent
    }),
    'LEAD_SE': /*#__PURE__*/React.createElement(MarketingTrack_LEAD_SE, {
      consent: marketingConsent,
      granularConsent: granularConsent
    }),
    'LEAD_NO': /*#__PURE__*/React.createElement(MarketingTrack_LEAD_NO, {
      consent: marketingConsent,
      granularConsent: granularConsent
    })
  }[site];
  return /*#__PURE__*/React.createElement(React.Fragment, null, marketingConsent || granularConsent ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MarketingTrack, {
    consent: marketingConsent,
    granularConsent: granularConsent
  }), countryElement) : null);
}

function DefaultTrack_FI(_ref) {
  useScript('https://www.googletagmanager.com/gtag/js?id=G-H31DLCCN2P');
  useScript('https://blok-tracking.storage.googleapis.com/FI/ga4.js');
  useScript('https://www.googletagmanager.com/gtag/js?id=UA-89720873-1');
  useScript('https://blok-tracking.storage.googleapis.com/FI/universal_ga.js');
  useScript('https://blok-tracking.storage.googleapis.com/FI/gtag.js');
  return null;
}

function DefaultTrack_SE(_ref) {
  useScript('https://www.googletagmanager.com/gtag/js?id=G-95RVFZDBXY');
  useScript('https://blok-tracking.storage.googleapis.com/SE/ga4.js');
  useScript('https://www.googletagmanager.com/gtag/js?id=UA-89720873-3');
  useScript('https://blok-tracking.storage.googleapis.com/SE/universal_ga.js');
  useScript('https://blok-tracking.storage.googleapis.com/SE/gtag.js');
  return null;
}

function DefaultTrack_NO(_ref) {
  useScript('https://www.googletagmanager.com/gtag/js?id=G-M8R3LVBDXR');
  useScript('https://blok-tracking.storage.googleapis.com/NO/ga4.js');
  return null;
}

function DefaultTrack_LEAD_SE(_ref) {
  useScript('https://www.googletagmanager.com/gtag/js?id=G-RZ6KRSS3DJ');
  useScript('https://blok-tracking.storage.googleapis.com/LEAD_SE/ga4.js');
  return null;
}

function DefaultTrack_LEAD_NO(_ref) {

  /* TODO */
  return null;
}

function DefaultTracking(_ref) {
  let {
    site
  } = _ref;
  const element = {
    'FI': /*#__PURE__*/React.createElement(DefaultTrack_FI, null),
    'SE': /*#__PURE__*/React.createElement(DefaultTrack_SE, null),
    'NO': /*#__PURE__*/React.createElement(DefaultTrack_NO, null),
    'LEAD_SE': /*#__PURE__*/React.createElement(DefaultTrack_LEAD_SE, null),
    'LEAD_NO': /*#__PURE__*/React.createElement(DefaultTrack_LEAD_NO, null)
  }[site];
  return element;
}

var css_248z = "@charset \"UTF-8\";\n/**\n* @license\n* MyFonts Webfont Build ID 3556768, 2018-04-12T01:44:02-0400\n* \n* The fonts listed in this notice are subject to the End User License\n* Agreement(s) entered into by the website owner. All other parties are \n* explicitly restricted from using the Licensed Webfonts(s).\n* \n* You may obtain a valid license at the URLs below.\n* \n* Webfont: ObjektivMk1-Bold by Dalton Maag\n* URL: https://www.myfonts.com/fonts/daltonmaag/objektiv/1bold/\n* \n* Webfont: ObjektivMk1-Medium by Dalton Maag\n* URL: https://www.myfonts.com/fonts/daltonmaag/objektiv/1medium/\n* \n* Webfont: ObjektivMk1-Regular by Dalton Maag\n* URL: https://www.myfonts.com/fonts/daltonmaag/objektiv/1regular/\n* \n* \n* License: https://www.myfonts.com/viewlicense?type=web&buildid=3556768\n* Licensed pageviews: Unlimited\n* Webfonts copyright: Copyright 2015 Dalton Maag Ltd. Modification of this file requires prior written permission from Dalton Maag Ltd.\n* \n* © 2018 MyFonts Inc\n*/\n@font-face {\n  font-family: \"ObjektivMk1-Bold\";\n  src: url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_0_0.eot\");\n  src: url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_0_0.eot?#iefix\") format(\"embedded-opentype\"), url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_0_0.woff2\") format(\"woff2\"), url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_0_0.woff\") format(\"woff\"), url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_0_0.ttf\") format(\"truetype\");\n  font-weight: normal;\n}\n@font-face {\n  font-family: \"ObjektivMk1-Medium\";\n  src: url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_1_0.eot\");\n  src: url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_1_0.eot?#iefix\") format(\"embedded-opentype\"), url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_1_0.woff2\") format(\"woff2\"), url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_1_0.woff\") format(\"woff\"), url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_1_0.ttf\") format(\"truetype\");\n  font-weight: normal;\n}\n@font-face {\n  font-family: \"ObjektivMk1-Regular\";\n  src: url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_2_0.eot\");\n  src: url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_2_0.eot?#iefix\") format(\"embedded-opentype\"), url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_2_0.woff2\") format(\"woff2\"), url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_2_0.woff\") format(\"woff\"), url(\"https://blok-fonts.storage.googleapis.com/webfonts/3645A0_2_0.ttf\") format(\"truetype\");\n  font-weight: normal;\n}\n/** Common **/\n/** main **/\n/** main **/\n/** main **/\n/** main **/\n/** TYPOGRAPHY **/\n/** reflect bootstrap screen size **/\n.ConsentPrompt-module_privacyConsentApp__Rvh6c {\n  font-family: \"ObjektivMk1-Regular\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif;\n}";
var styles = {"privacyConsentApp":"ConsentPrompt-module_privacyConsentApp__Rvh6c"};
styleInject(css_248z);

var BLOK_APP_URL = 'https://app.blok.ai';
var PERMITTED_EVENTS = ['get', 'set', 'error', 'loaded', 'manage']; // NOTE: country is deprecated, site should be used

function ConsentPrompt(_ref) {
  var _ref$country = _ref.country,
      country = _ref$country === void 0 ? 'FI' : _ref$country,
      _ref$site = _ref.site,
      site = _ref$site === void 0 ? null : _ref$site,
      _ref$language = _ref.language,
      language = _ref$language === void 0 ? 'en' : _ref$language,
      _ref$promptoff = _ref.promptoff,
      promptoff = _ref$promptoff === void 0 ? null : _ref$promptoff,
      _ref$baseUrl = _ref.baseUrl,
      baseUrl = _ref$baseUrl === void 0 ? BLOK_APP_URL : _ref$baseUrl,
      _ref$debug = _ref.debug,
      debug = _ref$debug === void 0 ? false : _ref$debug;
  var iframeRef = useRef(null);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showBar = _useState2[0],
      setShowBar = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showManage = _useState4[0],
      setShowManage = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      updates = _useState6[0],
      setUpdates = _useState6[1];

  var _useState7 = useState({
    analytics: true,
    marketing: true
  }),
      _useState8 = _slicedToArray(_useState7, 2),
      consentForm = _useState8[0],
      setConsentForm = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      consentVerified = _useState10[0],
      setConsentVerified = _useState10[1];

  var PERMITTED_DOMAIN = baseUrl;
  site = site || country;
  useEffect(function () {
    // receiving message from the iframe from app.blok.ai
    window.addEventListener('message', receiveMessage); // clean up the event handler when the component unmounts

    return function () {
      return document.removeEventListener('message', receiveMessage);
    };
  }, []);

  var receiveMessage = function receiveMessage(event) {
    // receive message from app.blok.ai
    if (!event.data) {
      return;
    }

    if (PERMITTED_DOMAIN !== event.origin || !PERMITTED_EVENTS.includes(event.data.type)) {
      return;
    }

    if (debug) {
      console.log('received', event.data, event.origin);
    }

    handleResult(event.data);
  };

  var _getCookie = function _getCookie(data) {
    if (data.result.consent) {
      return data.result.consent;
    } // old consent


    if (data.result.consent_v1) {
      return {
        analytics: false,
        marketing: false,
        parties: data.result.consent_v1
      };
    }

    return null;
  };

  var handleResult = function handleResult(data) {
    switch (data.type) {
      case 'loaded':
        // iframe sent msg that it has loaded, request consent data
        checkConsent();
        return;

      case 'manage':
        promptManage();
        return;

      case 'set':
        if (data.result.cookie_saved) {
          api.set('blok_consent_client', data.result.cookie_value);
          setConsentVerified(true);
        }

        return;

      case 'get':
        if (!data.result.consent && !data.result.consent_v1) {
          // consent does not exist
          setShowBar(true);
          return;
        }

        if (data.result.consent && data.result.is_outdated) {
          // consent outdated
          setConsentForm({
            analytics: data.result.consent.analytics,
            marketing: data.result.consent.marketing
          }); // show new privacy updates

          setUpdates(data.result.updates);
          return;
        } // new or old consent should exist


        var cookie = _getCookie(data);

        if (!cookie) {
          console.error('missing consent', data);
          return;
        } // cookie exists and up to date


        api.set('blok_consent_client', JSON.stringify(cookie));
        setConsentVerified(true);
        return;

      case 'error':
        console.error(data.result);
    }
  };

  var postCrossDomainMessage = function postCrossDomainMessage(msg) {
    if (debug) {
      console.log('posting', msg, baseUrl);
    }

    iframeRef.current.contentWindow.postMessage(msg, baseUrl);
  };

  var checkConsent = function checkConsent() {
    // always check for get from app.blok.ai to make sure the consent is to latest dpa
    // NOTE: Sending client_cookie info fixes issue where Safari does not save cookies.
    // Possible cause is that Safari discards cookies set in an iframe(?). If consent cookie
    // in app.blok.ai is missing, use client_cookie as fallback (which has same data as
    // consent cookie should have)
    var msg = {
      type: 'get',
      site: site,
      language: language,
      client_cookie: api.get('blok_consent_client')
    };
    postCrossDomainMessage(msg);
  };

  var promptManage = function promptManage() {
    setShowBar(false);
    setShowManage(true);
  };

  var saveConsent = function saveConsent(consent) {
    api.set('blok_consent_client', JSON.stringify(consent));
    var msg = {
      type: 'set',
      consent: consent,
      site: site
    };
    postCrossDomainMessage(msg);
    setShowBar(false);
    setShowManage(false);
    setUpdates(null);
  };

  var acceptAll = function acceptAll() {
    saveConsent({
      analytics: true,
      marketing: true
    });
  };

  var setConsentField = function setConsentField(field, value) {
    var consent = _objectSpread2(_objectSpread2({}, consentForm), {}, _defineProperty({}, field, value));

    setConsentForm(consent);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: styles.privacyConsentApp
  }, /*#__PURE__*/React.createElement("iframe", {
    ref: iframeRef,
    style: {
      display: 'none'
    },
    src: "".concat(baseUrl, "/privacy/consent_iframe/") //onLoad={checkConsent} // this is not reliable, instead let's wait that iframe posts "loaded" msg

  }), showBar && !promptoff ? /*#__PURE__*/React.createElement(ConsentBar$2, {
    promptManage: promptManage,
    acceptAll: acceptAll,
    translation: getTranslation(site, language)
  }) : null, showManage && !promptoff ? /*#__PURE__*/React.createElement(ConsentManageModal, {
    consentForm: consentForm,
    setConsentField: setConsentField,
    saveConsent: saveConsent,
    translation: getTranslation(site, language)
  }) : null, updates && !promptoff ? /*#__PURE__*/React.createElement(ConsentUpdateModal, {
    updates: updates,
    consentForm: consentForm,
    saveConsent: saveConsent,
    translation: getTranslation(site, language)
  }) : null, /*#__PURE__*/React.createElement(DefaultTracking, {
    site: site
  }), consentVerified ? /*#__PURE__*/React.createElement(OptionalTracking, {
    site: site
  }) : null);
}

export { ConsentPrompt };
